<template lang="pug">
    b-container
        b-modal(
            id="processing_modal"
            v-model="modal_state"
            no-close-on-backdrop=true
            no-close-on-esc=true
            ok-disabled=true
            cancel-disabled=true
            lazy
        )
            div(slot="modal-header")
                | Processing
            div(slot="modal-footer")
            p
                |{{ message }}
            b-img(center :src="imgToStaticPath('spinner.gif')" alt="Loading")
</template>

<script>
export default {
	props: ["message"],
	data() {
		return {
			modal_state: false
		};
	},
	methods: {
		show_modal() {
			this.modal_state = true;
		},
		hide_modal() {
			this.modal_state = false;
		},
		set_state(val) {
			this.modal_state = val;
		}
	}
};
</script>

<style scoped></style>
